import { ReactNode } from 'react';

type BadgeVariant = 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'outline';

interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  size?: 'sm' | 'md';
  className?: string;
}

export const Badge = ({
  children,
  variant = 'default',
  size = 'md',
  className = ''
}: BadgeProps) => {
  const baseClasses = 'inline-flex items-center rounded-full font-medium';

  const variantClasses = {
    default: 'bg-surface-card text-text-secondary border border-slate-700/50',
    primary: 'bg-gradient-to-r from-primary-500 to-primary-600 text-white shadow-sm',
    success: 'bg-gradient-to-r from-green-500/90 to-emerald-600/90 text-white shadow-sm',
    warning: 'bg-gradient-to-r from-amber-500/90 to-orange-500/90 text-white shadow-sm',
    danger: 'bg-gradient-to-r from-red-500/90 to-pink-600/90 text-white shadow-sm',
    outline: 'bg-transparent text-text-tertiary border border-slate-600/70'
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm'
  };

  return (
    <span className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}>
      {children}
    </span>
  );
};